import { fonts } from './assets/fonts/fonts';
import { createGlobalStyle, css } from 'styled-components';

export const theme = {
  dark: {},
  light: {},
  colours: {
    BrightGray: '#EBEBEB',
    Lotion: '#FBFBFB',
    AntiFlashWhite: '#F2F2F2',
    white: '#FFFFFF',
    black: '#000000',
    error: '#B11E1E',
    red: '#F80707',
    red_2: '#CC0000',
    violet: '#422475',
    beer: '#FA8F21',
    gray: '#666666',
    gray2: '#727272',
    Turquoise: '#49CDC0',
    LightSilver: '#D8D8D8',
    spaceCadet: '#25314C',
    gray3: '#989898',
    gray4: '#7E7E7E',
    gray5: '#969696',
    lightgray5: '#F4F4F4',
    SpanishGray: '#9D9D9D',
    Nickel: '#6E7176',
    NewCar: '#0C58DB',
    Platinum: '#E7E7E7',
    black2: '#000000',
    blackText: '#000000',
  },
  fonts: {
    ExtraBold: 'ExtraBold',
    SemiBold: 'SemiBold',
    Bold: 'Bold',
    Regular: 'Regular',
    Medium: 'Medium',
  },
  space_size: '8px',
  brekpoints: {
    smallMobile: '360px',
    tablet: '768px',
    bigTablet: '1024px',
    desketop: '1280px',
  },
  Snippets: {
    textOverflowHide: css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `,
  },
};

export const GlobalStyles = createGlobalStyle`
	${fonts}

	*{
		padding: 0;
		margin: 0;
		direction: rtl;
		box-sizing: border-box;
		font-family: ${theme.fonts.Regular}, sans-serif;
		&:lang(en) {
			direction: ltr;
			text-align: left;
  	}
	};

	html, body, #root, .App{
		min-height: 100dvh;
		background-color: #F2F2F2;
	}
	html{
		overflow-x:hidden;
		::-webkit-scrollbar {
      width: 4px;
    }

	body {
  overscroll-behavior-y: contain;
	}
	html, body {
	height: 100%;
	overflow: hidden;
	}
	.scroll-container {
	height: 100%;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	}

    ::-webkit-scrollbar-track {
      background-color: #eaeaea;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #7F7F99;
      border-radius: 4px;
    }
	}
	.App{
		position: relative;
		display: grid ;
		grid-template-rows:auto 1fr auto;
	}
	.Bold{
		font-family: ${theme.fonts.Bold};
	}
	.ExtraBold{
		font-family: ${theme.fonts.ExtraBold};
	}
	.SemiBold{
			font-family: ${theme.fonts.SemiBold};
		}
	.Regular{
			font-family: ${theme.fonts.Regular};
		}
	.Medium{
			font-family: ${theme.fonts.Medium};
		}
	.ErrorMessageStyle{
		color: ${theme.colours.error};
		font-size: 13px;
		font-family: ${theme.fonts.Medium};
		min-height: 25px;
		display: flex;
		align-items: flex-end;
	}
	.mantine-RadioGroup-label{
		font-family: ${theme.fonts.Medium};
		font-size: 14px;
		margin-bottom: 8px;
		color: ${theme.colours.NewCar};
		font-weight: 400;
	}
	.button_scroll{
		button{
			width: 44px;
			height: 44px;
			border-radius: 50%;
			background-color:  ${theme.colours.NewCar};
			padding: 0;
			&:hover{
				background-color:  ${theme.colours.NewCar};
			}
		}
	}
	.detail_modal{
		.mantine-Modal-inner{
			top: 100dvw;
			padding: 0;
			.mantine-Paper-root{
				position: absolute;
				bottom: 0;
    			width: 100%;
			}
		}
	}
	.mantine-Container-root{
		width: 100vw;
    @media (max-width: 768px) {
      padding-right: 0px;
      padding-left: 0px;
    }
	}
	.status-options-dropdown{
		width: 150px !important;
		@media (max-width: 768px) {
			width: 110px !important;
		}
	}
	.servicesWrapper{
		*{

			direction: rtl !important;
			text-align: right !important;
		}
		#event-search{

			.search_wrappeer {
		padding: 4px 6px;
		border-radius: 8px;
		background-color: ${theme.colours.white};
		.mantine-Input-rightSection {
			right: initial !important;
		}
		.mantine-Autocomplete-icon{
			right: initial !important;
			left:0 !important;

		}
		input {
			padding-left: 72px !important;
			padding-right: 0 !important;
		}
	  }
		}
	}
	button{
		border-radius: 12px !important;
	}
	input:-webkit-autofill,
  input:-webkit-autofill:focus,
  input:-internal-autofill-selected {
background-color: white !important;
  }

	.actions{
		.cancelBtn{
		  border-radius: 12px;
		  min-width: 85px;
		  height: 36px;
		  background-color: ${theme.colours.AntiFlashWhite};
		  color: ${theme.colours.black};
		  font-weight: 400;
		  font-size: 14px;
		  cursor: pointer;
		  display: flex;
          justify-content: center;
          align-items: center;
	  }
	}
	.special-event-details{
display: flex;
align-items: center;
flex-direction: column;
width:492px;
gap:16px;
padding:4px;
padding-top:0;
margin-top:60px;
@media (max-width:500px) {
width: 100%;
}
	}
	.event-details {
  background-color: #ffffff;
  padding: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  border-radius:12px;
  width: 500px;
  @media (max-width: 500px) {
	  width:100%;
  }
  .action-wrapper{
	width:100% !important;
	button{
	  width:50%;
	  height: 40px;
	  border-radius: 8px !important;
	  font-size: 14px;
	  font-family: ${theme.fonts.Regular};
	}
	.reschedule{
	  border:1px solid #EBEBEB;
	}
  }
  .cancel-note{
	background-color: white;
	padding: 0;
	p{
		font-family: ${theme.fonts.SemiBold};
		font-size: 18px;
		font-weight: 600;
		line-height: 22px;
	}
  }
  .rescheduleMeeting{
	margin-top: 16px;
	font-family: ${theme.fonts.Regular};
	font-size :13px;
	height: 40px;
  }
}

.success-footer {
    text-align: center;
    color: ${theme.colours.black};
    font-size: 14px;
    a {
      cursor: pointer;
      text-decoration: none;
    }
  }

input[type='email']{
	text-align: left !important;
}

.react-select__option--is-selected {
	background-color: #000000 !important;
	color: white;
      }
      
      .react-select__option--is-focused:not(.react-select__option--is-selected) {
		background-color: rgb(242, 242, 242) !important;
	}

.mantine-Select-dropdown {
    .mantine-Select-item[data-hovered='true'] {
      background-color: rgb(242, 242, 242) !important;
    }
    .mantine-Select-item[data-selected='true'] {
      background-color: #000000 !important;
    }
  }

  .mantine-ScrollArea-scrollbar{
    right: unset !important;
    left: 0 !important;
    &::-webkit-scrollbar {
        width: 3px !important;
      }

      &::-webkit-scrollbar-track {
        border-radius: 3px !important;
        box-shadow: inset 0 0 6px rgb(230, 230, 230) !important;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgb(240, 240, 240) !important;
        border-radius: 3px !important;
      }

      width: 8px !important;


      .mantine-ScrollArea-thumb{
        background-color: rgb(230, 230, 230) !important;
        border-radius: 3px !important;
      }
  }

  .mantine-DateInput-day{
    background-color: rgb(242, 242, 242) !important;
    border-radius: 4px !important;
    color: ${theme.colours.black} !important;
    &[data-outside]{
      color: white !important;
      display: none !important;
    }
    &[data-weekend]{
      color: ${theme.colours.black} !important;
    }
    &[data-selected]{
      background-color: #000000 !important;
      color: white !important;
    }
    &[data-weekend][data-selected]{
      background-color: #000000 !important;
      color: white !important;
    }
    &:hover{
      border: 1px solid #000000 !important;
    }
  }

  // Additional rules for date picker components
  .mantine-DatePicker-day{
    &[data-weekend]{
      color: ${theme.colours.black} !important;
    }
    &[data-weekend][data-selected]{
      color: white !important;
    }
  }

  button[data-weekend][data-selected] {
    color: white !important;
  }

  /* Override @jadwalh/ui's Input/QuestionInput label color (library still uses
     its own near-black token) without touching the shared library. */
  .label p {
    color: #000000 !important;
  }

	@media (max-width:768px) {
			.spaceBetween{
			justify-content: space-between;
			height: calc(100vh - 100px);
		}

	}

	.mantine-Modal-inner{
		right: 0 !important;
	}
`;
